
export const DEFAULT_LANG = 'en';
export const REQUEST_SOURCE = 'DOER-ERP';
export const REQUEST_SERVICE_SOURCE = 'schoolerp-portal';


export const DUPLICATE_LOGIN_ID_RESPONSE_CODE = 'Duplicate.Login.Id';
export const DUPLICATE_EIIN_NUMBER_RESPONSE_CODE = 'Duplicate.Eiin.Number';

export const loginCookieStoreKey = 'login.doererp.cookie.store.key';
export const reportJsonCookieStoreKey = 'login.doererp.cookie.store.report.json';
export const userNameStoreKey = 'login.doererp.cookie.store.username.key';
export const mobileNoStoreKey = 'login.doererp.cookie.store.mobileNo.key';
export const employeeName = 'login.doererp.cookie.store.employeeName.key';
export const employeeId = 'login.doererp.cookie.store.employeeId.key';
export const employeeOid = 'login.doererp.cookie.store.employeeOid.key';
export const userIdStoreKey = 'login.doererp.cookie.store.userid.key';
export const roleIdStoreKey = 'login.doererp.cookie.store.roleoid.key';
export const emailStoreKey = 'login.doererp.cookie.store.email.key';
export const branchStoreKey = 'login.doererp.cookie.store.branch.key';
export const branchOidStoreKey = 'login.doererp.cookie.store.branchoid.key';
export const cspStoreKey = 'login.doererp.cookie.store.csp.key';
export const cspOidStoreKey = 'login.doererp.cookie.store.cspoid.key';
export const loginOidStoreKey = 'login.doererp.cookie.store.loginoid.key';
export const clusterOidStoreKey = 'login.doererp.cookie.store.clusteroid.key';
export const agentClusterOidStoreKey = 'login.doererp.cookie.store.agentClusterOid.key';

export const USER_INFO_LOCAL_STORAGE_KEY = 'doererp.login.user.info.local.storage.key';

export const CLIENT_ID = '3C:A9:F4:34:02:B8';
export const APPLICATION_NAME = 'DOER-ERP';
export const APPLICATION_SERVICE_NAME = 'DOER-ERP-Portal';
export const CLIENT_NAME = 'doer';
export const REQUEST_VERSION = '1.0';
export const REQUEST_TIMEOUT_IN_SECONDS = 120;
export const PAGE_SIZE = 10;
export const JPG_EXTENTION = '.jpg';
export const DEFAULT_APP_LANGUAGE = 'bn';
export const LANGUAGE_BANGLA = 'বাংলা';
export const LANGUAGE_ENGLISH = 'English';
export const USER_IMG_PATH = 'assets/images/photo/user/';
export const imagePath = 'assets/images/photo/';
export const DEFAULT_INSTITUTE_LOGO_PATH = 'assets/images/photo/';
export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50, 100];
export const STATUS_ACTIVE = 'Active';
export const STATUS_INACTIVE = 'Inactive';
export const STATUS_LOADED = 'Loaded';
export const STATUS_SEND_SMS = 'Sent';
export const STATUS_VALID = 'Valid';
export const STATUS_INVALID = 'Invalid';
export const mobileNoRegEx = '^(0|[0+]880)1[3-9][0-9]{8}$';
export const EmailRegEx = '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$';
export const DEFAULT_IMAGE_SIZE_IN_KB = 200;
export const PERIOD_EN = 'Period';
export const PERIOD_BN = 'পিরিয়ড';
export const YES = 'Yes';
export const NO = 'No';
export const REPORT_TYPE_PDF = 'pdf';
export const REPORT_TYPE_CSV = 'csv';
export const REPORT_TYPE_XLS = 'xls';
export const REPORT_TYPE_ZIP = 'zip';
export const STATUS_NOT_BATCHED = 'notBatched';
export const STATUS_CREATED = 'created';
export const STATUS_BATCHED = 'batched';
export const STATUS_PAID = 'Paid';
export const STATUS_SUBMITTED = 'Submitted';
export const STATUS_APPROVED = 'Approved';
export const STATUS_PENDING = 'Pending';
export const STATUS_SELECTED = 'Selected';
export const STATUS_REJECTED = 'Rejected';
export const STATUS_PUBLISHED = 'Published';
export const STATUS_PRE_REVIEWING = 'preReviewing';
export const STATUS_REVIEWING = 'reviewing';
export const STATUS_REVIEWED = 'reviewed';
export const INVALID_TOKEN = '401';
export const DATABASE_DATE_FORMAT = 'YYYY-MM-DD';
export const UI_FORM_DATE_FORMAT = 'YYYY-MMM-DD';
export const VIEW_FULL_DATE_FORMAT = 'Do MMMM, YYYY';


export const DEMO_INSTITUTE_OID = 'SCHOOL-ERP-Demo-School-001';

export const ROLE_TYPE_ADMIN = 'Admin';
export const ROLE_TYPE_INSTITUTE = 'Institute';
export const ROLE_TYPE_TEACHER = 'Teacher';
export const ROLE_TYPE_STUDENT = 'Student';
export const ROLE_TYPE_GUARDIAN = 'Guardian';

export const ADMISSION_FEE_HEAD_GROUP_CODE = '101'; 